import React from 'react';
import { usePermissionContext } from '../../contexts/PermissionContext';

function Footer() {
  const { company } = usePermissionContext();
  const userStr = sessionStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  const isSuperAdmin = user?.role === 'SUPER_ADMIN';

  return (
    <footer className="app-footer">
      <div className="app-footer__inner">
        © {new Date().getFullYear()} {isSuperAdmin ? 'Super Admin' : (company?.companyName || 'Asencia')}
      </div>
    </footer>
  );
}

export default Footer;
